'use client';

import CustomRandomReveal from '@/lib/utils/CustomRandomReveal';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

const Intro = () => { // Wesley: hard check just so the landing page has a h1...
  const pathname = usePathname();
  const isLandingPage = pathname === '/';
  const IntroHeadingTag = isLandingPage ? 'h1' : 'h2';

  const _renderTextName = (titles: string[]) => {
    const [count, setCount] = useState(0);
    const caret = typeof document !== 'undefined' ? document.getElementsByClassName("typewriter-container")[0] : undefined;

    return (
      <span className="typewriter-container pause">
        <CustomRandomReveal
          previous={titles[count]}
          next={titles[count === (titles.length - 1) ? 0 : count + 1]}
          interval={100}
          delay={2}
          caret={caret}
          onComplete={() => {
            if (count === titles.length - 1) {
              setCount(0);
            }
            else {
              setCount(count + 1);
            }
          }}
        />
      </span>
    )
  };

  return (
    <div className='content-left-box'>
      <IntroHeadingTag className='text-gray letter-scrambler'>{`\\\\INTRO\\\\`}</IntroHeadingTag>
      <div>
        <p className='letter-scrambler'>
          WE RUN ON EXPERIMENTATION AND CREATIVITY.
          INVENTED FROM ADVERTISING AND PRODUCTION SPHERES,
          THE OTHER LAB THRIVES ON MATERIALISING IDEAS WITH A TEAM OF HIGHLY SKILLED
          <span> {_renderTextName(['CREATIVES', 'SUITS', 'DEVELOPERS', 'PROGRAMMERS', 'ARTISTS', 'ILLUSTRATORS', 'DESIGNERS'])}</span>
        </p>
      </div>
      <p className={'text-gray'}>{'<>'}</p>
    </div>
  )
};

export default Intro;
